import React, { memo } from 'react'
import { IEnrollmentFieldCheckerProps } from './Enrollment.interfaces'

function EnrollmentFieldChecker (props: IEnrollmentFieldCheckerProps) {
  const { excludedFields, nameField, children } = props
  return excludedFields.includes(nameField) ? null : <>{children}</>
}

export default memo(EnrollmentFieldChecker)
